function whenAvailable(selector, callback) {
    const interval = setInterval(function() {
        if (document.querySelector(selector)) {
            clearInterval(interval);
            callback();
        }
    }, 100);
}

whenAvailable("option", function() {
    document.querySelectorAll('option').forEach(option => {
        if (option.innerText.includes('USD')) {
            option.innerText = option.innerText.replace('USD', 'CAD');
        }
    });
});